import {createApp, VueElement} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "@/assets/style/common.less"
import "@/assets/font/iconfont.css"
import {
    registerOrderComponents,
    registerProductComponents,
    registerStoreComponents
} from "@/utils/module/asyncComponents";
// import "@/assets/style/lppz-btn.less"

const app = createApp(App)
for (let elementPlusIconsVueKey in ElementPlusIconsVue) {
    app.component(elementPlusIconsVueKey, ElementPlusIconsVue[elementPlusIconsVueKey])
}
registerProductComponents(app)
registerOrderComponents(app)
registerStoreComponents(app)

app.use(store).use(router).use(ElementPlus, {
    locale: zhCn
}).mount('#app')
